import React from 'react';

function BloodGroupingForm() {
  return (
    <div>
      <h2>BloodGroupingForm</h2>
    </div>
  );
}

export default BloodGroupingForm;
